import React from 'react';
import { motion } from 'framer-motion';
import { User } from 'lucide-react';
const testimonials = [{
  quote: 'Вони не просто зробили ідеальну подію, вони перевершили всі наші очікування. Рівень сервісу, який важко знайти.',
  author: 'Олена В.',
  role: 'CEO, Tech Innovators'
}, {
  quote: 'Кожна деталь нашого весілля була бездоганною. Це була справжня магія, створена командою професіоналів.',
  author: 'Максим та Анна',
  role: 'Приватні клієнти'
}];
export function Testimonials() {
  return <section id="testimonials" className="py-24 bg-surface" data-id="element-151">
      <div className="max-w-7xl mx-auto px-6" data-id="element-152">
        <div className="text-center mb-16" data-id="element-153">
          <h2 className="text-3xl md:text-4xl font-semibold mb-4" data-id="element-154">
            Відгуки клієнтів
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-155">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-background p-8 rounded-3xl border border-border flex flex-col" data-id="element-156">
              <p className="text-lg text-primary leading-relaxed mb-8 flex-grow" data-id="element-157">
                "{item.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-158">
                <div className="w-10 h-10 rounded-full bg-surface flex items-center justify-center text-secondary" data-id="element-159">
                  <User size={18} data-id="element-160" />
                </div>
                <div data-id="element-161">
                  <div className="font-medium text-sm text-primary" data-id="element-162">
                    {item.author}
                  </div>
                  <div className="text-xs text-secondary" data-id="element-163">{item.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}